import { ticketDetailsViewTypes } from '@twiliointernal/services-common/containers/TicketDetailsView';

/**
 * Returns a list of collaborators' emails given the ticket details.
 */
export const getCollaboratorsFromTicket = (
  ticketDetails: ticketDetailsViewTypes.TicketDetails,
): string[] => {
  // Ticket users is a list of all user objects (admins, agents, collaborators) participating in the ticket.
  // emailCcIds are Zendesk User IDs of all ticket collaborators.
  const { users: ticketUsers = [], emailCcIds = [] } = ticketDetails;

  // Isolate the email addresses of only email CCs from the ticket users.
  const collaborators = ticketUsers.reduce<string[]>(
    (accum, { email, id }) =>
      emailCcIds.includes(id) ? [...accum, email] : accum,
    [],
  );

  return collaborators;
};
